import { Component, ElementRef, OnInit, ViewContainerRef, effect, inject, viewChild } from '@angular/core';
import { AuthService } from './@core/Auth/auth.service';
import { ComponentFactory } from './@core/services/ComponentFactory/component-factory.service';
import { TokenService } from './@core/services/token.service';
import { OnlineStatusService, OnlineStatusType } from 'ngx-online-status';
import { debug } from 'ngxtension/debug';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import {faFarm,faPersonChalkboard, faHatBeach, faUsers, faHome, faEllipsisStrokeVertical, faSidebar, faUserPlus, faCheck, faMap, faXmark, faVectorPolygon, faArrowPointer, faScalpelLineDashed, faTrash, faDrawPolygon, faTable, faBox, faPlus, faMinus, faTableRows, faLock, faLockOpen, faUpload, faSignalStream} from '@fortawesome/duotone-regular-svg-icons'
import { fromEvent, map, filter, shareReplay, switchMap, exhaustMap, take, tap, distinctUntilChanged, EMPTY } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SignalRService } from './@core/services/signalR.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false
})
export class AppComponent implements OnInit {
  title = 'Laguna Bay Web Map';

  private readonly authService = inject(AuthService);
  private readonly componentFactory = inject(ComponentFactory);
  private readonly signalRService = inject(SignalRService);
  private readonly tokenService = inject(TokenService)
  private readonly onlineStatusService: OnlineStatusService = inject(OnlineStatusService);
  private readonly library: FaIconLibrary = inject(FaIconLibrary);

  container = viewChild.required('componentContainer',{read: ViewContainerRef});

  constructor(private viewContainerRef:ViewContainerRef) {

    this.library.addIcons(faCheck, faMap,faXmark,faVectorPolygon, faArrowPointer, faScalpelLineDashed, faTrash,faDrawPolygon, faTable, faBox, faPlus, faMinus,faTableRows,faLock,faLockOpen,faUpload,faSignalStream);


    this.onlineStatusService.status.pipe(
      distinctUntilChanged(),
      switchMap(status =>
        status === OnlineStatusType.OFFLINE
          ? this.signalRService.stopConnection()
          : this.authService.isAuthenticated().pipe(
              filter(Boolean),
              switchMap(() => this.signalRService.slice.status$.pipe(
                map(status => status === 'connected' ? true : false),take(1))),
              switchMap(isConnected =>
                isConnected
                  ? EMPTY
                  : this.signalRService.startConnection()
              )
            )
      ),

      takeUntilDestroyed()
    ).subscribe();


    if (typeof Worker !== 'undefined') {

      const worker = new Worker(new URL('./stand-by-checker.worker.ts', import.meta.url));

      const resume$ = fromEvent<MessageEvent>(worker, 'message').pipe(
        map((e) => e.data),
        filter((msg) => msg?.type === 'resume'),
        shareReplay({ bufferSize: 1, refCount: true })
      );


      resume$.pipe(
        exhaustMap(() => this.authService.isAuthenticated()),
        filter(Boolean),
        switchMap(() => this.signalRService.slice.status$.pipe(
          map(status => status === 'connected' ? true : false),take(1))),
        switchMap(isConnected =>
          isConnected
            ? EMPTY
            : this.signalRService.startConnection()
        ),
        takeUntilDestroyed()
      ).subscribe();

    } else {

    }

    effect(()=>{
      const container = this.container();

      this.componentFactory.setTarget(container);
    })

  }
  ngOnInit(): void {

  }


}
